<template>
  <div>
    <Div class="border">
      <h4 class="mb-2 text-info">
        {{
          "number_service_additional"
            | setText("Номер сервиса дополнительной гарантии")
        }}:
        <span v-if="data.exchange_id">{{ data.exchange_id }}</span>
        <span v-else>{{
          "request_not_sent" | setText("Запрос не отправлен")
        }}</span>
      </h4>
    </Div>
    <component :is="data.state" :data="data" v-model="setValue" />
  </div>
</template>
<script>
export default {
  methods: {},
  components: {
    new: () => import("./new"),
    sent: () => import("./sent"),
    cancel: () => import("./cancel"),
  },
  data: () => ({}),
  props: ["value", "data"],
  computed: {
    setValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
<style>
</style>
 